/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { LocalStorageService } from '@hcworkspace/sysque/toolbelt/utils';
import { ApplyConduitIdReturnCodes, ApplyEquipmentDeviceIdReturnCodes } from '../models/apply-id-return-codes';
import { GlobalConstants } from '../constants/global-constants';
export class ApplyIdReceiveController {
  constructor(private localStorageService: LocalStorageService) {}

  public ApplyConduitIdResult(response: ApplyConduitIdReturnCodes): void {
    this.localStorageService.updateDispatchLocalStorage(GlobalConstants.ApplyIdResponseKey, JSON.stringify(response));
  }

  public ApplyEquipmentDeviceIdResult(response: ApplyEquipmentDeviceIdReturnCodes): void {
    this.localStorageService.updateDispatchLocalStorage(GlobalConstants.ApplyIdResponseKey, JSON.stringify(response));
  }
}
